import script from "./ActivityLogItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityLogItem.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityLogItem.vue?vue&type=style&index=0&id=e90c89c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e90c89c2"]])

export default __exports__